const FULLSCREEN_KEY = 'fullscreen_status'
const REVERSE_SIDEBAR_KEY = 'reverse_sidebar_status'
// TODO: Pre-defined connect
const POS_ID_KEY = 'pos_id'

const CdService = {
  /**
   * Keep the fullscreen in the localstorage
   * @param status {boolean}
   */
  saveFullscreenStatus (status) {
    localStorage.setItem(FULLSCREEN_KEY, Boolean(status).toString())
    changeFullscreen(status)
  },

  /**
   * Get the current fullscreen status
   * @returns {boolean}
   */
  getFullscreenStatus () {
    const result = localStorage.getItem(FULLSCREEN_KEY) || false
    if (result !== false) {
      changeFullscreen(result === 'true')
      return result === 'true'
    }
    changeFullscreen(false)
    return false
  },

  /**
   * Keep the reverseSidebar in the localstorage
   * @param status {boolean}
   */
  saveReverseSidebarStatus (status) {
    localStorage.setItem(REVERSE_SIDEBAR_KEY, Boolean(status).toString())
  },

  /**
   * Get the current reverseSidebar status
   * @returns {boolean}
   */
  getReverseSidebarStatus () {
    const result = localStorage.getItem(REVERSE_SIDEBAR_KEY) || false
    if (result !== null) return result === 'true'
    return false
  },

  /**
   * Keep the reverseSidebar in the localstorage
   * @param id {string || number}
   */
  savePosId (id) {
    localStorage.setItem(POS_ID_KEY, Number(id).toString())
  },

  /**
   * Get the current reverseSidebar status
   * @returns {number | null}
   */
  getPosId () {
    return Number(localStorage.getItem(POS_ID_KEY)) || null
  }
}

// Helper for change FullScreen status
function changeFullscreen (value) {
  if (document.fullscreenEnabled) {
    console.log(document.fullscreenElement)
    if (value) {
      if (document.fullscreenElement === null) {
        // Timeout for fix set fullscreen after reload page
        setTimeout(() => {
          document.documentElement.requestFullscreen()
            .catch((e) => {
              console.log('requestFullscreenError', e)
            })
        }, 50)
      }
    } else {
      if (document.fullscreenElement !== null) document.exitFullscreen()
    }
  } else {
    console.log('Fullscreen API is not supported.')
  }
}

export default CdService



// WEBPACK FOOTER //
// ./src/services/cd.service.js